import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Comments, FilesComponent, Notes, SimpleTabs } from 'components';
import { commentModels, fileEnums, noteModels, PermissionList, RolePermission } from 'utils';
import { ClaimPaymentDetailHeader } from './claimPaymentDetailHeader';
import { HistoryTab } from 'fragments';
import { claimPaymentTabsLabels } from './constants';
import { ClaimPaymentDetails } from './claimPaymentDetails';
import { formModelEnums } from '../../../forms';

export const ClaimPaymentInfo = () => {
    const remittanceById = useSelector((state) => state.claimPayment.remittanceById);
    const params = useParams();

    const claimPaymentTabContent = [
        {
            tabComponent: <ClaimPaymentDetails />,
            tab: 'Details',
        },

        {
            tabComponent: (
                <Comments
                    fromDetail={true}
                    resource={commentModels.Remittance}
                    resourceId={params?.id}
                    label={'Claim'}
                    width={700}
                    height={600}
                    attachmentPurpose={'Claim'}
                    enableAiImprove
                />
            ),
            tab: 'Comments',
        },

        RolePermission([PermissionList.CLAIM_NOTE_READ?.code, PermissionList.CLAIM_NOTE_MANAGE?.code]) && {
            tabComponent: (
                <Notes
                    id={params?.id}
                    onModel={noteModels.Claim}
                    formModel={formModelEnums.CLAIMNOTES}
                    permissions={[PermissionList.CLAIM_NOTE_MANAGE?.code]}
                />
            ),
            tab: 'Notes',
        },
        RolePermission([PermissionList.CLAIM_HISTORY_READ?.code]) && {
            // tabComponent: <HistoryTab currentId={remittanceById?.id} onModel={'Remittance'} />,
            tabComponent: <HistoryTab currentId={params?.id} onModel={'Remittance'} />,
            tab: 'History',
        },
        RolePermission([PermissionList.CLAIM_FILE_READ?.code, PermissionList.CLAIM_FILE_MANAGE?.code]) && {
            tabComponent: (
                <FilesComponent
                    currentId={params?.id}
                    onResource={fileEnums.REMITTANCE}
                    permissions={[PermissionList.CLAIM_FILE_MANAGE?.code]}
                />
            ),
            tab: 'Files',
        },
    ];

    if (!remittanceById) {
        return <div />;
    }

    return (
        <div className="tab-box-wrapper">
            <ClaimPaymentDetailHeader />
            <SimpleTabs defaultTab={'Details'} tabsLabels={claimPaymentTabsLabels} tabsContent={claimPaymentTabContent} />
        </div>
    );
};
